import { isAndroidApp, isIOSApp, isMobileApp } from 'utils';
/**
 * Fixes the ESP touch for the given parameters for android.
 *
 * @param {string} apSsid - The SSID of the access point.
 * @param {string} apBssid - The BSSID of the access point.
 * @param {string} apPassword - The password of the access point.
 * @param {number} deviceCountData - The number of devices.
 * @param {'0' | '1'} broadcastData - The broadcast data.
 * @param {(success: {bssid: string; ip: string}) => void} success_callback - The success callback function.
 * @param {(error: string) => void} fail_callback - The fail callback function.
 * @return {void}
 */
export function fixEspTouch(apSsid, apBssid, apPassword, deviceCountData, broadcastData, success_callback, fail_callback) {
    if (isMobileApp()) {
        if (isAndroidApp()) {
            // @ts-ignore
            return window.esptouch.start?.(apSsid, apPassword, deviceCountData, broadcastData, fail_callback, success_callback);
        }
        if (isIOSApp()) {
            return window.esptouch.start?.(apSsid, apBssid, apPassword, deviceCountData, broadcastData, success_callback, fail_callback);
        }
    }
}
